
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/DodaFront/View/CareerRecommendJobList",
      function () {
        return require("private-next-pages/DodaFront/View/CareerRecommendJobList/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/DodaFront/View/CareerRecommendJobList"])
      });
    }
  